import React from 'react';
import PropTypes from 'prop-types';
import BtnBase from './base';

const ShareBtn = ({
  className, onClick, label, icon,
}) => <BtnBase iconAfter={icon} className={`${className}`} onClick={onClick} label={label}/>;

ShareBtn.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

export default ShareBtn;
